<!--
 * @Descripttion: 优惠弹框
 * @Author: Yang Maoxiang
 * @Date: 2020-08-25 14:27:10
 * @LastEditTime: 2024-05-20 18:13:53
-->
<template>
  <v-os-popup v-if="currentCoupon" :show="isShow" title="优惠明细" @close="close" :footerShow="false" container="body">
    <div class="detail">
      <!-- 到手价计算 -->
      <div class="discount-container">
        <!-- 优惠结果 -->
        <div class="discount-result" tabindex="0">
          <div class="result-price" v-text="commodityDiscountPrice"></div>
          <div class="result-title" v-text="isDepositBuy ? '实付金额' : '当前购买'"></div>
        </div>
        <!-- 优惠明细 -->
        <div class="discount-detail" v-if="commodityEstimatedCouponList.length != 0">
          <div class="detail-arrow"></div>
          <!-- 市场价/划线价 -->
          <div
            class="pre-price"
            :class="{ 'pre-price-small': commodityEstimatedCouponList.length > 3 }"
            v-if="prePrice"
            v-text="prePrice"
            :aria-label="`当前售价${prePrice}`"
          ></div>
          <div v-for="(item, index) in commodityEstimatedCouponList" :key="index" style="display: flex" tabindex="0">
            <div
              class="line"
              :class="{ 'line-small': commodityEstimatedCouponList.length > 3 }"
              v-if="index != 0"
            ></div>
            <discountDetail
              :item="item"
              :smallFlag="commodityEstimatedCouponList.length > 3"
              :class="index == 0 ? discountMargin : ''"
            ></discountDetail>
          </div>
        </div>
      </div>
      <!-- 积分抵现 -->
      <div
        class="points-container points-margin"
        v-if="commodityPoints && commodityPoints.supportFlag"
        v-track="[
          {
            act: 'click',
            params: {
              cfrom: '237|004|01|077',
              event_id: '237|004|01|077',
              page_name: pageName,
              sku_id: skuId
            }
          }
        ]"
        tabindex="0"
        @click="openPointDescriptionPopup"
      >
        <div class="points">
          <div class="points-title" v-text="'积分当钱花'"></div>
          <div
            class="points-info"
            v-if="commodityPoints.pointsMoney && commodityPoints.pointsMoney > 0"
            v-text="`${this.isDepositBuy ? '尾款阶段' : ''}积分最多可抵${commodityPoints.pointsMoney}元`"
          ></div>
          <div v-else class="points-info" v-text="'当前商品支持积分抵现'"></div>
        </div>
        <div class="ponits-more"></div>
      </div>
      <!-- 满减活动 -->
      <div class="points-container points-margin" v-if="commodityOrderMyjyAct" tabindex="0">
        <div class="points">
          <div class="points-title" v-text="'满减活动'"></div>
          <div class="points-info" v-text="commodityOrderMyjyAct.actBounsDesc"></div>
        </div>
      </div>

      <div class="discount">
        <ul class="discount-content">
          <li class="discount-content-list">
            <div class="coupon-list">
              <!-- 可领取 -->
              <template v-if="couponRuleVos.length">
                <div class="received-box">
                  <div class="header">
                    <h3 class="title">可领取优惠券</h3>
                  </div>
                  <v-coupon
                    :coupon="item"
                    :type="item.couponStatus ? 2 : 4"
                    :couponFlag="item.couponFlag"
                    :longitude="longitude"
                    :latitude="latitude"
                    btn-name="可用商品"
                    v-for="(item, index) in couponRuleVos"
                    :key="index + '-couponRuleVos'"
                    v-track="[
                      {
                        act: 'show',
                        params: {
                          cfrom: '237|002|02|077',
                          event_id: '237|002|02|077',
                          page_name: pageName,
                          coupon_id: item.couponUuid,
                          coupon_status: 2,
                          sku_id: skuId
                        }
                      },
                      {
                        act: 'click',
                        params: {
                          cfrom: '237|002|01|077',
                          event_id: '237|002|01|077',
                          page_name: pageName,
                          coupon_id: item.couponUuid,
                          coupon_status: 2,
                          sku_id: skuId
                        }
                      }
                    ]"
                  ></v-coupon>
                </div>
              </template>
              <!-- 已领取 -->
              <template v-if="userCouponVos.length">
                <div class="received-box">
                  <div class="header">
                    <h3 class="title">已领取优惠券</h3>
                  </div>
                  <v-coupon
                    :coupon="item"
                    :type="item.couponStatus ? 2 : 1"
                    :couponFlag="item.couponFlag"
                    :btnType="0"
                    :hasReceive="item.couponStatus == 0"
                    btn-name="可用商品"
                    v-for="(item, index) in userCouponVos"
                    :key="index + '-userCouponVos'"
                    v-track="[
                      {
                        act: 'show',
                        params: {
                          cfrom: '237|002|02|077',
                          event_id: '237|002|02|077',
                          page_name: pageName,
                          coupon_id: item.couponUuid,
                          coupon_status: 1,
                          sku_id: skuId
                        }
                      },
                      {
                        act: 'click',
                        params: {
                          cfrom: '237|002|01|077',
                          event_id: '237|002|01|077',
                          page_name: pageName,
                          coupon_id: item.couponUuid,
                          coupon_status: 1,
                          sku_id: skuId
                        }
                      }
                    ]"
                  ></v-coupon>
                </div>
              </template>
              <!-- 升级可领取 -->
              <div class="received-box" v-if="upgradeCouponVos.length">
                <div class="header">
                  <h3 class="title">升级会员可得如下优惠券</h3>
                  <div class="upgrade" v-if="!env.isIOSVivoApp && !env.isPadVivoApp">
                    <div
                      @click="goTo(memberCenter)"
                      class="member-enter"
                      v-track="[
                        {
                          act: 'click',
                          params: {
                            cfrom: '237|005|01|077',
                            event_id: '237|005|01|077',
                            page_name: pageName,
                            sku_id: skuId
                          }
                        }
                      ]"
                    >
                      如何升级
                    </div>
                  </div>
                </div>
                <v-coupon
                  :coupon="item"
                  :type="item.couponStatus ? 2 : 5"
                  :couponFlag="item.couponFlag"
                  v-for="(item, index) in upgradeCouponVos"
                  :key="index + '-upgradeCouponVos'"
                  v-track="[
                    {
                      act: 'show',
                      params: {
                        cfrom: '237|002|02|077',
                        event_id: '237|002|02|077',
                        page_name: pageName,
                        coupon_id: item.couponUuid,
                        coupon_status: 3,
                        sku_id: skuId
                      }
                    },
                    {
                      act: 'click',
                      params: {
                        cfrom: '237|002|01|077',
                        event_id: '237|002|01|077',
                        page_name: pageName,
                        coupon_id: item.couponUuid,
                        coupon_status: 3,
                        sku_id: skuId
                      }
                    }
                  ]"
                ></v-coupon>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </v-os-popup>
</template>

<script>
import { getUserCoupon } from '../../index/api'
import config from 'config'
import env from '@/utils/clientEnv'
import { mapState, mapGetters, mapActions } from 'vuex'
import { formatNumber } from '@/utils/common'
import discountDetail from './components/discountDetail.vue'
export default {
  name: 'DiscountPopup',
  components: { discountDetail },
  data() {
    return {
      memberCenter: config.path.memberCenter,
      // estimatedCouponVos：到手价使用的券，couponRuleVos：其他待领取优惠券，upgradeCouponVos：升级后领取的优惠券，userCouponVos：已领取优惠券
      currentCoupon: null,
      env
    }
  },
  props: {
    isShow: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isShow(val) {
      val && !this.currentCoupon && this.getUserCoupon()
    },
    // 监听skuId变化，currentCoupon设置为空
    skuId() {
      if (!this.isShow) {
        this.currentCoupon = null
      }
    }
  },
  computed: {
    ...mapState('detailv3', ['skuInfo', 'installment', 'longitude', 'latitude', 'selectParams']),
    ...mapGetters('detailv3', [
      'spuId',
      'skuId',
      'stagingInfo',
      'fullDiscount',
      'commodityEstimated',
      'isDepositBuy',
      'commodityDeposite',
      'isQuickBuy',
      'isCustomAtmosphere',
      'discountType'
    ]),
    // 埋点参数page_name
    pageName() {
      return this.discountType == 'group' ? 2 : 1
    },
    discountMargin() {
      if (this.commodityEstimatedCouponList.length <= 4) {
        return `discount-margin-${this.commodityEstimatedCouponList.length}`
      } else {
        return ''
      }
    },
    //处理到手价优惠券模型
    commodityEstimatedCouponList() {
      // 有套餐时，不显示价格公式
      if (this.selectParams.currentSuite?.id) {
        // 存在套餐价
        return []
      }
      let result = []
      // 判断是否为定金预售
      if (this.isDepositBuy && this.skuInfo?.commoditySkuDiscount?.commodityEstimated?.myjyAct) {
        let counpon = {
          couponName: '定金预售',
          couponFlag: 5,
          //满减文案
          couponRuleDesc: `￥${parseFloat(this.commodityDeposite.depositAmount)}抵￥${
            this.commodityDeposite.depositSwellAmount
          }`,
          discountFee: this.skuInfo.commoditySkuDiscount.commodityEstimated.myjyAct.discountFee //满减金额
        }
        result.unshift(counpon)
      }
      // 过滤免息券，不在计算模型中展示
      const commodityEstimatedCouponList = (
        this.skuInfo?.commoditySkuDiscount?.commodityEstimated?.commodityEstimatedCouponList || []
      ).filter(item => item.couponFlag != 2)
      // 判断是否含有移动特惠
      const contractPhoneDiscount = this.skuInfo?.commoditySkuDiscount?.commodityEstimated?.contractPhoneAct?.discountFee
      if(contractPhoneDiscount > 0) {
        let counpon = {
          couponName: '移动用户特惠',
          couponFlag: 6,
          couponRuleDesc: `补贴${contractPhoneDiscount}元`,//移动特惠文案
          discountFee: contractPhoneDiscount //补贴金额
        }
        result.unshift(counpon)
        // 存在到手价券模型时
        if (commodityEstimatedCouponList && commodityEstimatedCouponList.length > 0 && !this.isDepositBuy) {
          const sumCouponDiscount = this.skuInfo?.commoditySkuDiscount?.commodityEstimated?.sumCouponDiscount || commodityEstimatedCouponList.reduce((pre, cur) => {
            return formatNumber (pre + (cur.discountFee - 0))
          }, 0)
          result.unshift({
            discountFee: sumCouponDiscount, //优惠总金额
            couponVoList: [...commodityEstimatedCouponList] // 优惠券列表
          })
        }
      } else {
        // 存在到手价券模型时
        if (commodityEstimatedCouponList && commodityEstimatedCouponList.length > 0 && !this.isDepositBuy) {
          //到手价券模型
          result = [...commodityEstimatedCouponList]
        }
      }
      //满减券模型
      if (this.commodityEstimated?.myjyAct && !this.isDepositBuy) {
        let counpon = {
          couponName: '满减活动',
          couponFlag: 2,
          //满减文案
          couponRuleDesc: this.commodityEstimated.myjyAct.actBounsDesc,
          discountFee: this.commodityEstimated.myjyAct.discountFee
        }
        result.unshift(counpon)
      }
      let counpon = {
        couponName: '活动价',
        couponFlag: 3,
        //满减文案
        couponRuleDesc: null,
        discountFee: this.isDepositBuy
          ? this.skuInfo?.commoditySkuBaseInfo?.salePrice
          : this.skuInfo?.commoditySkuDiscount?.commodityDiscountPrice || this.skuInfo?.commoditySkuBaseInfo?.salePrice
      }
      //判断为活动价还是原价，市场价和销售价相同，且不存在抢购价
      if (
        this.skuInfo?.commoditySkuBaseInfo?.marketPrice == this.skuInfo?.commoditySkuBaseInfo?.salePrice &&
        !this.isQuickBuy &&
        !this.isCustomAtmosphere
      ) {
        counpon.couponName = '当前售价'
        counpon.couponFlag = 4
      }
      if (result.length > 0) {
        result.unshift(counpon)
        return result
      } else {
        return []
      }
    },
    //优惠后的价格，有到手价显示到手价，无到手价显示销售价(已包含优惠)或销售价,有套餐，显示套餐价
    commodityDiscountPrice() {
      if (this.selectParams.currentSuite?.id) {
        return this.selectParams?.currentSuite?.totalPrice
      } else if (this.isDepositBuy) {
        //定金预售显示销售价
        return this.commodityEstimated?.commodityEstimatedPrice || this.skuInfo?.commoditySkuBaseInfo?.salePrice
      } else {
        return (
          this.commodityEstimated?.commodityEstimatedPrice ||
          this.skuInfo?.commoditySkuDiscount?.commodityDiscountPrice ||
          this.skuInfo?.commoditySkuBaseInfo?.salePrice ||
          this.skuInfo?.commoditySkuBaseInfo?.marketPrice
        )
      }
    },
    //划线价
    prePrice() {
      //市场价和销售价相等，且没有优惠价时，则没有划线价，否则市场价为划线价
      //判断销售价与市场价是否相同或者没有抢购，相同则没有划线价，不同则销售价为活动价，市场价为划线价
      if (
        this.skuInfo?.commoditySkuBaseInfo?.marketPrice == this.skuInfo?.commoditySkuBaseInfo?.salePrice &&
        !this.isQuickBuy &&
        !this.isCustomAtmosphere
      ) {
        return null
      } else {
        return this.skuInfo?.commoditySkuBaseInfo?.marketPrice
      }
    },
    //商详积分抵扣信息
    commodityPoints() {
      return this.skuInfo?.commoditySkuDiscount?.commodityPoints
    },
    //商详满减信息
    commodityOrderMyjyAct() {
      return this.skuInfo?.commoditySkuDiscount?.commodityOrderMyjyAct
    },
    /**
     * 可领优惠券
     */
    couponRuleVos() {
      return this.dealCoupon(this.currentCoupon?.couponRuleVos)
    },
    /**
     * 已领优惠券
     */
    userCouponVos() {
      return this.dealCoupon(this.currentCoupon?.userCouponVos)
    },
    /**
     * 升级后可领优惠券
     */
    upgradeCouponVos() {
      return this.dealCoupon(this.currentCoupon?.upgradeCouponVos)
    },
    // 会员等级vo
    memberLevelInfoDtos() {
      return this.currentCoupon?.memberLevelInfoDtos
    }
  },
  methods: {
    ...mapActions('detailv3', ['changePointDescriptionPopupStatus', 'savePreFocusElByEvent']),
    openPointDescriptionPopup(e) {
      this.changePointDescriptionPopupStatus(true)
      this.savePreFocusElByEvent(e)
    },
    goTo(url) {
      setTimeout(() => {
        location.href = url
      }, 100)
    },
    /**
     * @description: 获取优惠券信息
     * @Author: Yang Maoxiang
     * @Date: 2020-09-11 10:45:25
     */
    async getUserCoupon() {
      let params = {
        spuId: this.spuId,
        skuId: this.skuId
      }
      if (this.longitude || this.latitude) {
        params.longitude = this.longitude
        params.latitude = this.latitude
      }
      let url = window.location.href
      const urlParam = Object.fromEntries(new URLSearchParams(url.split('?')[1]))
      const { purchaseChannel, liveRoomId, liveSceneId } = urlParam
      if (purchaseChannel == 1) {
        params.purchaseChannel = purchaseChannel
      }
      if (liveRoomId) {
        params.liveRoomId = liveRoomId
      }
      if (liveSceneId) {
        params.liveSceneId = liveSceneId
      }
      //v9.5.0商详页改版新增一字段
      if (this.commodityEstimated?.commodityEstimatedCouponList) {
        params.couponUuids = []
        this.commodityEstimated.commodityEstimatedCouponList.forEach(el => {
          params.couponUuids.push(el.couponUuid)
        })
      }
      let data = await getUserCoupon(params).catch(() => {})
      if (data) {
        this.currentCoupon = data
      }
    },
    /**
     * @description: 处理接口和优惠券组件之间字段对应关系
     * @Author: Yang Maoxiang
     * @Date: 2020-08-26 10:45:32
     */
    dealCoupon(list) {
      let newCoupon = []
      if (list && list.length) {
        list.forEach(item => {
          // 券ICON设置
          if (item.memberLevelCode > 1 && !item.levelIconWithTextUrl && this.memberLevelInfoDtos?.length > 0) {
            item.levelIconWithTextUrl = this.memberLevelInfoDtos.find(member => member.level == item.memberLevelCode)?.levelIconWithTextUrl || ''
          }
          newCoupon.push({
            ...item,
            id: item.couponUuid,
            couponName: item.couponFlag ? '可与优惠券叠加使用' : item.couponName,
            wapUseUrl: config.path.shopUrl + '/coupon/couponUsableList?couponNum=' + item.couponNum
          })
        })
      }
      return newCoupon
    },
    /**
     * @description: 关闭弹窗
     * @Author: Yang Maoxiang
     * @Date: 2020-08-25 11:14:44
     */
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
<style lang="scss" scoped src="../../index/dark-popup.scss"></style>